import React from "react";
import Box from '@material-ui/core/Box';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

const styles = {
  resultInner: {
    paddingTop: "20px",
    paddingBottom: "20px"
  }
}

const SearchBar = ({handleInputChange, query, searchedPosts}) => {
  console.log(searchedPosts);
  console.log(query)
   return (
   	<div>
   		<div className="result-inner">
        <SearchBox handleInputChange={handleInputChange} />
   			<div className="result-inner__res" style={styles.resultInner} >
   				{query !== "" ?
   					'"' + query + '" の検索結果: ' + searchedPosts.length + "件"
   					: searchedPosts.length + "件の記事があります"
   				}
   			</div>
   		</div>
   	</div>
   )
}

const SearchBox = ({handleInputChange}) => {
  return (
    <Box sx={{ '& > :not(style)': { m: 1 }}}>
      <TextField
        id="search-text-field"
        placeholder="Search posts by title, category, or date"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        onChange={handleInputChange}
      />
    </Box>
  );
}

export default SearchBar;